import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { Component, OnInit, inject } from '@angular/core';

import { AuthenticationService } from '../../services';


@Component({
	selector: 'login-page',
	templateUrl: './login-page.component.html',
	imports: [LoaderSpinnerComponent]
})
export class LoginPageComponent implements OnInit {
	private authenticationService = inject(AuthenticationService);


	ngOnInit() {
		this.authenticationService.login();
	}
}
